import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/main.less'
import '@/assets/fonts/fonts.css' // 引入字体

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import { Message } from 'element-ui'
Vue.use(ElementUI)


import qs from 'qs'

Vue.prototype.$qs = qs

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

/* 保存文件 */
import { saveAs } from 'file-saver'
Vue.prototype.$saveAs = saveAs


import { DETAIL_DATASETCODE_MAP } from '@/utils/staticData'

/* 跳转详情页公用方法    
  mediaType为视频图片跳转详情专用：1-图片 2-视频
*/
function goDetail({ _id, data_type, media_type }) {
  let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {}
  const { map } = userInfo
  let right = map ? JSON.parse(map)?.detailRight : 1
  console.log(`rightMap=${map}`, `right=${right}`);
  if (right == 1) {
    let detailObj = DETAIL_DATASETCODE_MAP[data_type]
    let path = detailObj.path
    let moduleCode = detailObj.moduleCode
    /* 视频和图片由于公用一个daty_type 因此需要单独处理 */
    if (media_type == 1) {
      moduleCode = 'RDPI_detail_image'
    } else if (media_type == 2) {
      moduleCode = 'RDPI_detail_video'
    }
    let resolve = router.resolve(path + `?id=${_id}&data_type=${data_type}&moduleCode=${moduleCode}`)
    window.open(resolve.href, '_blank')
  } else {
    Message({
      message: '无页面访问权限',
      type: 'warning',
      customClass: 'messageIndex'
    })
  }
}
Vue.prototype.$goDetail = goDetail

// 跳转专题详情
function goSpecialDetail(item) {
  // 若route有值，则跳转对应路由，无则跳转一般路由
  // 若route没有，则为一般专题详情
  let path = item.route ? item.route : '/generalTopic'
  let resolve = router.resolve(path + `?title=${item.country ? item.country : item.title}&&id=${item.id}`)
  window.open(resolve.href, '_blank')
}

Vue.prototype.$goSpecialDetail = goSpecialDetail

// 获取数据累心
Vue.prototype.$getDataType = (data) => {
  return Object.prototype.toString.call(data).slice(8, -1)
}

var dayjs = require('dayjs')
Vue.prototype.$dayjs = dayjs


import lazyLoad from 'vue-lazyload'
Vue.use(lazyLoad, {
  loading: require("./assets/imgs/loading.gif"), //加载成功图片
  // error: require("./assets/imgs/error.png"),  //加载失败图片
  error: require("./assets/imgs/placeholder/no_img.png"),  //加载失败图片
  try: 1 //加载图片数量
})

/* 公共组件 */
import myPage from '@/components/pagination/page.vue'
Vue.component('myPage', myPage)

Vue.config.productionTip = false


// 拖拽任一位置指令
Vue.directive('draggable', (el, binding) => {
  let oDiv = el // 当前元素
  // let self = this // 上下文
  // 禁止选择网页上的文字
  document.onselectstart = function () {
    return false
  }
  oDiv.onmousedown = function (e) {
    // 鼠标按下，计算当前元素距离可视区的距离
    let disX = e.clientX - oDiv.offsetLeft
    let disY = e.clientY - oDiv.offsetTop
    document.onmousemove = function (e) {

      //3、移动时，鼠标距离当前窗口x轴坐标 - 鼠标在拖拽元素的坐标 = 剩下距离body的x轴坐标
      //将这个数值设置为拖拽元素的left、top
      var boxLeft = e.clientX - disX;
      var boxTop = e.clientY - disY;
      //获取body的页面可视宽高
      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      var clientWidth = document.documentElement.clientWidth || document.body.clientWidth
      //4、限制拖拽宽高
      /* if (boxLeft < 0) {
        boxLeft = 0;
        //如果拖拽元素定位的数值高于, 页面可视宽 - 拖拽元素自身宽 (可视页面最大宽)
      } else if (boxLeft > clientWidth - oDiv.offsetWidth) {
        //满足这个条件，就限制宽为，clientWidth-oDiv.offsetWidth(可视页面最大宽)
        boxLeft = clientWidth - oDiv.offsetWidth;
      } */

      if (boxTop < 0) {
        boxTop = 0;
        //如果拖拽元素定位的数值高于, 页面可视高 - 拖拽元素自身高 (可视页面最大高)
      } else if (boxTop > clientHeight - oDiv.offsetHeight) {
        //满足这个条件，就限制高为，clientHeight-oDiv.offsetHeight(可视页面最大高)
        boxTop = clientHeight - oDiv.offsetHeight;
      }

      //↑将数值设置成拖拽元素的定位left、top
      oDiv.style.left = boxLeft + "px";
      oDiv.style.top = boxTop + "px";
      oDiv.style.cursor = 'move'
    }
    document.onmouseup = function (e) {
      document.onmousemove = null
      document.onmouseup = null
    }
    // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
    return false
  }
})

/* 复制文本 */
/* ----------复制文本----------- */
const copyText = async (textToCopyValue) => {
  /* 处理需要赋值的文本---最后的链接不要 */
  let aAreaIndex = textToCopyValue.indexOf('以上信息来自于')
  let textToCopy = aAreaIndex > -1 ? textToCopyValue.slice(0, aAreaIndex) : textToCopyValue
  // navigator clipboard 需要https等安全上下文
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard 向剪贴板写文本
    return navigator.clipboard.writeText(textToCopy).then(() => {
      Message.success('复制成功')
    }).catch(err => {
      Message.error('err')
    });
  } else {
    // 创建text area
    let textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    // 使text area不在viewport，同时设置不可见
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      // 执行复制命令并移除文本框
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    }).then(() => {
      Message.success('复制成功')
    }).catch(err => {
      Message.error(err)
    });
  }
}
Vue.prototype.$copy = copyText


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


//全局防抖动
const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200)
    super(callback)
  }
}